import React, { useState } from 'react'
import styled from 'styled-components'
import { useDropzone } from 'react-dropzone'
import { fileToBase64 } from 'helpers'
import Resizer from 'react-image-file-resizer';
import Grid from '@material-ui/core/Grid'
import AvatarCropper from 'components/AvatarCropper'
import Modal from '@material-ui/core/Modal'
import ReactAvatarEditor from 'react-avatar-editor'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPen, faTimes, faTrash } from '@fortawesome/free-solid-svg-icons'
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined';
const API_URL = 'http://localhost:3000'

const StyledDropZone = styled.div`
  position: relative;
  width: 7rem;
  height: 7rem;
  margin: auto;
  margin-left: 6px;
  margin-top: 15px;
  border-style: solid;
  border-width: 1px;
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgb(242,245,250);
  overflow: hidden;
  max-width: 100%;
  display: inline-block;
  ${({error}) => `
    border-color: ${error ? 'red' : 'white'}
  `}
  &:hover {
  }
`

const PicturePreview = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height : 100%;
  z-index: 3;
  border: none;
  object-fit: cover;
`

const StyledButton = styled.button`
  border: none;
  background: transparent;
  font-size: 16px;
  color: #98a1b3;
  font-weight: 400;
  vertical-align: bottom;

  svg {
    margin-right: 5px;
    height: 15px;
    vertical-align: baseline;
  }
`

const DeleteOutlinedIconStyled = styled.div`
.MuiSvgIcon-root {
  font-size: 12px !important;
  vertical-align: text-bottom !important;
  height: 10px !important;
}
`

const sendRequest = (file) => {
  return new Promise((resolve, reject) => {
    const req = new XMLHttpRequest();

    const formData = new FormData();
    formData.append("file", file, file.name);

    req.open("POST", "http://localhost:8000/upload");
    req.send(formData);
  });
}

const ImageDropZone = ({
  children,
  onChange,
  value,
  error,
  showModal
}) => {
  const [openModal, setOpenModal] = useState(false)

  const {getRootProps, getInputProps} = useDropzone({
    accept: 'image/*',
    maxSize: 10000000,
    onDrop: async acceptedFiles => {
      if (acceptedFiles.length > 0) {
        // const formData = new FormData()
        // formData.append(0, acceptedFiles[0])
        // fetch(`${API_URL}/upload`, {
        //   method: 'POST',
        //   body: formData
        // })
        // .then(res => res.json())
        // .then(images => {
        //   console.log(images)
        // })

        // sendRequest(acceptedFiles[0])
        setOpenModal(true)
        Resizer.imageFileResizer(
          acceptedFiles[0],
          500,
          500,
          'JPEG',
          100,
          0,
          uri => {
            onChange(uri)
          },
          'base64'
        );
      }
    }
  });

  const saveImage = (img) => {
    onChange(img)
    setOpenModal(false)
  }
  const rootProps = getRootProps();
  const inputProps = getInputProps();
  console.info('rootProps', rootProps)
  console.info('inputProps', inputProps)

  return (
    <>
      <Grid container spacing={0}>
        <Grid item xs={12}>
          <StyledDropZone
            {...rootProps}
            className={'dropzone'}
            error={error}
          >
            <input {...inputProps} />
            {value && <PicturePreview src={value} />}
            {children}
          </StyledDropZone>
          <div className="photo-links">
          {value &&
              <>
                <StyledButton onClick={() => setOpenModal(true)}>
                  <FontAwesomeIcon icon={faPen} /> Edytuj zdjęcie
                </StyledButton><br />
                <StyledButton onClick={() => saveImage(null)}>
                <FontAwesomeIcon icon={faTrash} /> Usuń zdjęcie
                </StyledButton>
              </>
            }
            { ! value &&
              <StyledButton className="addPhotoButton" {...rootProps}>
                <p> Dodaj zdjęcie</p>
              </StyledButton>
            }
            </div>
          </Grid>

      </Grid>
      <Modal
        open={openModal}
      >
        <>
          <AvatarCropper
            image={value}
            onImageSave={saveImage}
          />
        </>
      </Modal>
    </>
  )
}

export default ImageDropZone
